import { ApiError } from 'api/http/types';
import { ApiState } from 'scenes/common/types';
import { ErrorPayload } from 'scenes/payments/types';
import { ErrorProps } from '../types';

export const isPostCodeError = ({ data }: ErrorProps) =>
  data?.ref?.toLowerCase() === 'postcode' ||
  data?.msg?.toLowerCase().includes('postcode');

export const nonBusinessApiError = (
  loadingStatus: ApiState,
  errorState?: ApiError<ErrorPayload>
) =>
  loadingStatus === ApiState.Error &&
  (!errorState || errorState?.name !== ApiState.BusinessError);

export const toStateError = (error: ApiError<ErrorPayload>) => ({
  name: error.name,
  httpCode: error.httpCode ?? '',
  data: error.data,
});
